import { useLang } from "@/lib/i18n";
import { useReveal } from "@/lib/useReveal";

export const Stats = () => {
  const { t } = useLang();
  const { ref, visible } = useReveal();

  return (
    <section
      data-testid="stats-section"
      ref={ref}
      className={`py-20 md:py-32 reveal-up ${visible ? "in-view" : ""}`}
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-12 gap-y-12 lg:gap-x-12 items-end mb-14 md:mb-20">
          <h2 className="col-span-12 lg:col-span-8 editorial-h text-4xl md:text-5xl lg:text-6xl">
            {t.stats.title}
          </h2>
          <div className="col-span-12 lg:col-span-4 overline lg:text-right">
            Girona · Costa Brava · Empordà
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12 md:gap-x-10">
          {t.stats.items.map((s, i) => (
            <div
              key={i}
              data-testid={`stat-${i}`}
              className="border-t border-neutral-300 pt-6"
            >
              <div className="font-serif text-5xl md:text-6xl lg:text-7xl tracking-tight leading-none mb-4">
                {s.num}
              </div>
              <div className="text-[13px] md:text-sm text-neutral-600 leading-snug max-w-[200px]">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
